import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEventListener } from "usehooks-ts";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CreateTaxPercentage,
  DeleteTaxPercentage,
  EditTaxPercentage,
  GetTaxPercentageById,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import { useGetPageData } from "../../../custom_hooks/useGetPageData";
import { Confirm } from "../../Confirmation/Confirm";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../Reactportal/ModalContext";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import ".././FormComponent.scss";

const AddTaxPercentage = ({
  show,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
  ReferenceFieldName = [],
  ReferFormKey = "",
}) => {
  const formRef = useRef({});
  const Form_Key = "Tax_Percentage";
  const [FormData, setFormdata] = useState({});
  const [toggle, settoggle] = useState(show ? show : false);
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
  const { pushModal, popModal,  } = useModalContext();
  const fielddata = fielddataRedux?.Tax_Percentage?.Selected_Row;
  const [selectedRows, setSelectedRows] = useState([]);
  const dispatch = useDispatch();
  const [allFieldsData, setAllFieldsData] = useState({});
  const { fields } = useGetPageData();
  const [formErrors, setFormErrors] = useState({});

  // Q & M
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });

  const [CreatingData, { loading: createTaxPercentageLoading }] = useMutation(CreateTaxPercentage);

  const [getTaxPercentageById] = useLazyQuery(GetTaxPercentageById, {
    fetchPolicy: "network-only",
  });

  const [EditingData, { loading: editTaxPercentageLoading }] = useMutation(EditTaxPercentage(fields));

  const [DeletingData, { loading: deleteTaxPercentageLoading }] = useMutation(DeleteTaxPercentage);

  const SalesInvoiceTypeLoadingState =
    deleteTaxPercentageLoading || editTaxPercentageLoading || createTaxPercentageLoading;

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Tax_Percentage?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (TypeOfPortal !== "Add") {
      getFormSectionAndFields().then(() => { });
      getTaxPercentageById({
        variables: {
          id: fielddata?._id,
        },
      }).then(({ data }) => {
        let SalesInvoiceData = { ...data?.getPercentage_MasterbyId };

        setAllFieldsData(SalesInvoiceData);
        updateValueForm(formRef, SalesInvoiceData);
      });
    } else {
      setAllFieldsData({});
    }
  }, [fielddata]);



  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key)
    }
  }, []);


  const { executeOperation }: { executeOperation: any } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let formData = FormData;
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);
  const BranchMutations = {
    CreatingData,
    EditingData,
    DeletingData,
  };

  const submit = async (closeAction) => {
    let Name = (ReferenceFieldName as { name: string }[])[0]?.name;
    const mutationFunction = getMutationFunction(operationType, BranchMutations);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data: any) => data,
        PageName: Form_Key,
        OnSuccess: (res) => {
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: ReferFormKey,
              data: {
                [Name]: res?.data?.createPercentage_Master || res?.data?.editPercentage_Master,
              },
            },
          });
          handleFormReset(formRef);
        },
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => {
        handleFormReset(formRef);
      },
      onSuccess: () => { },
      onError: (error: any) => {
        ErrorToast((error as Error).message);
      },
    });
  };

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    setAllFieldsData({});
    ClearSpecificForm(dispatch, Form_Key);
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };



  if (TypeOfPortal === "Delete") {
    return (
      <Confirm submit={submit} settoggle={settoggle} toggle={toggle} loadingState={SalesInvoiceTypeLoadingState} />
    );
  }

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      TypeOfPortal={TypeOfPortal}
      Form_key={Form_Key}
      
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => {
            Validate_handleSubmit(SaveAndCloseForAdd);
          }
          : () => {
            Validate_handleSubmit(submit);
          }
      }
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={SalesInvoiceTypeLoadingState}
    />
  );

  return (
    <div>
      <Reactportal FoooterContent={footerContent} open={toggle} onClose={Closeformfunction} TypeOfPortal={TypeOfPortal}>
        <div className="SalesContainerr">
          <div className="salesInvoceContainer">
            {inputFields?.length > 0 ? (
              inputFields.map((e) => (
                <FormInputSectionComponent
                  key={e.id}
                  inputfields={e.fields}
                  Type={e.name}
                  TypeOfPortal={TypeOfPortal}
                  onErrorsChange={handleErrorsChange}
                  onhandleFormikChange={HanldeChangeonForm}
                  formkey={Form_Key}
                  formRef={formRef}
                />
              ))
            ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
              <p style={{ textAlign: "center" }}>No form fields available.</p>
            ) : null}
          </div>
        </div>
      </Reactportal>
    </div>
  );
};

export default AddTaxPercentage;
